export const LOCAL_STORAGE_KEY_HLW_WORD_SPACING = "hlwWordSpacing";
